module.exports = __webpack_public_path__ + "img/20200502_203717.9ae81227.jpg";